var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
        },
      ],
    },
    [
      _c(
        "el-card",
        { staticClass: "scene-control-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("场景")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-options" },
            [
              _c(
                "el-checkbox-group",
                {
                  staticClass: "config-options-checkbox",
                  model: {
                    value: _vm.baseInfo.checkedScene,
                    callback: function ($$v) {
                      _vm.$set(_vm.baseInfo, "checkedScene", $$v)
                    },
                    expression: "baseInfo.checkedScene",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: "1" } }, [
                    _c("i", { staticClass: "el-icon-food" }),
                    _vm._v(" 堂食\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _c("i", { staticClass: "el-icon-shopping-bag-2" }),
                    _vm._v(" 自提\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _c("i", { staticClass: "el-icon-truck" }),
                    _vm._v(" 外卖\n        "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: {
                    size: "mini",
                    type: "primary",
                    icon: "el-icon-s-check",
                  },
                  on: { click: _vm.saveEntity },
                },
                [_vm._v("\n        更新场景\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: {
                    size: "mini",
                    type: "primary",
                    icon: "el-icon-s-shop",
                  },
                  on: { click: _vm.handleStoreMenu },
                },
                [_vm._v("\n        适用门店\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.selectScene,
              expression: "this.selectScene",
            },
          ],
          staticClass: "scene-menu-container",
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: { mode: "horizontal", "default-active": _vm.selectScene },
              on: { select: _vm.handleSceneSelect },
            },
            [
              _vm.selectedScenes.indexOf("1") !== -1
                ? _c("el-menu-item", { attrs: { index: "1" } }, [
                    _c("i", { staticClass: "el-icon-food" }),
                    _vm._v("\n        堂食\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedScenes.indexOf("2") !== -1
                ? _c("el-menu-item", { attrs: { index: "2" } }, [
                    _c("i", { staticClass: "el-icon-shopping-bag-2" }),
                    _vm._v("\n        自提\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedScenes.indexOf("3") !== -1
                ? _c("el-menu-item", { attrs: { index: "3" } }, [
                    _c("i", { staticClass: "el-icon-truck" }),
                    _vm._v("\n        外卖\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scene-actions" },
            [
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "success",
                    icon: "el-icon-view",
                  },
                  on: { click: _vm.handlePreviewTemplate },
                },
                [_vm._v("\n        预览\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "primary",
                    icon: "el-icon-edit",
                  },
                  on: { click: _vm.handleEditTemplate },
                },
                [_vm._v("\n        编辑模版\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: _vm.isAllSelected ? "info" : "primary",
                    icon: _vm.isAllSelected ? "el-icon-close" : "el-icon-check",
                  },
                  on: { click: _vm.handleSelectAll },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isAllSelected ? "取消全选" : "全选") +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "success",
                    icon: "el-icon-document-copy",
                  },
                  on: { click: _vm.handleSyncMenu },
                },
                [_vm._v("\n        同步菜单\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "primary",
                    icon: "el-icon-folder-add",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleBatchChangeStatus(1)
                    },
                  },
                },
                [_vm._v("\n        批量上架\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "warning",
                    icon: "el-icon-folder-remove",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleBatchChangeStatus(0)
                    },
                  },
                },
                [_vm._v("\n        批量下架\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: {
                    size: "medium",
                    type: "primary",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.handleGroupAddVisible },
                },
                [_vm._v("\n        添加菜单分组\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "tac" },
        [
          _c("el-col", { attrs: { span: 4 } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectScene,
                    expression: "selectScene",
                  },
                ],
                staticClass: "group-tree-container",
              },
              [
                _c("div", { staticClass: "group-tree-header" }, [
                  _c("span", [_vm._v("菜单分组")]),
                ]),
                _vm._v(" "),
                _c("el-tree", {
                  ref: "groupTree",
                  staticClass: "group-tree",
                  attrs: {
                    data: _vm.treeData,
                    props: {
                      label: "groupName",
                      value: "id",
                      children: "children",
                    },
                    "node-key": "id",
                    "highlight-current": "",
                    draggable: "",
                    "allow-drag": _vm.allowDrag,
                    "allow-drop": _vm.allowDrop,
                    "default-expand-all": "",
                  },
                  on: {
                    "node-click": _vm.handleGroupSelect,
                    "node-drop": _vm.onGroupDragEnd,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c("span", { staticClass: "custom-tree-node" }, [
                          data.id !== "all"
                            ? _c("i", {
                                staticClass: "el-icon-more",
                                staticStyle: {
                                  cursor: "move",
                                  color: "#909399",
                                  "margin-right": "5px",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(node.label))]),
                        ])
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "group-block-container", attrs: { span: 20 } },
            _vm._l(_vm.templateGroupItems, function (detail) {
              return _c(
                "div",
                {
                  key: detail.id,
                  staticClass: "group-block",
                  attrs: { id: "group-block-" + detail.id },
                },
                [
                  _c("div", { staticClass: "group-header" }, [
                    _c("div", { staticClass: "group-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(detail.groupName) +
                          "|" +
                          _vm._s(detail.groupNameEn) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-time" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(detail.beginTimeStr) +
                          " - " +
                          _vm._s(detail.endTimeStr) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "group-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [{ name: "waves", rawName: "v-waves" }],
                            staticClass: "filter-item",
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddGroupItem(detail.id)
                              },
                            },
                          },
                          [_vm._v("\n              添加菜品\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [{ name: "waves", rawName: "v-waves" }],
                            staticClass: "filter-item",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleGroupDelete(detail.id)
                              },
                            },
                          },
                          [_vm._v("\n              删除分组\n            ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value:
                            _vm.loadingGroupIdsMap[detail.id] ||
                            _vm.listLoading,
                          expression:
                            "loadingGroupIdsMap[detail.id] || listLoading",
                        },
                      ],
                      key: detail.id,
                      ref: "table_" + detail.id,
                      refInFor: true,
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: detail.items,
                        stripe: "",
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                      },
                      on: {
                        "sort-change": function ($event) {
                          return _vm.handleTableSortChange($event, detail)
                        },
                        "selection-change": function (selection) {
                          return _vm.handleSelectionChange(selection, detail)
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "排序", width: "60", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-rank",
                                    staticStyle: {
                                      cursor: "move",
                                      "font-size": "18px",
                                      color: "#909399",
                                    },
                                    attrs: { "data-id": row.id },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品id",
                          prop: "goodsId",
                          align: "center",
                          width: "100",
                          sortable: "custom",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品名称",
                          prop: "goodsName",
                          align: "center",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品编码",
                          prop: "goodsCode",
                          align: "center",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "菜品价格",
                          align: "center",
                          width: "120",
                          prop: "price",
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n              ￥" +
                                      _vm._s(row.price) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "状态",
                          prop: "status",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "inactive-color": "#ff4949",
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleStatusChange(
                                          $event,
                                          row
                                        )
                                      },
                                    },
                                    model: {
                                      value: row.status,
                                      callback: function ($$v) {
                                        _vm.$set(row, "status", $$v)
                                      },
                                      expression: "row.status",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "生效星期",
                          prop: "name",
                          align: "center",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(1) !== -1
                                    ? _c("span", [_vm._v("周一")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(2) !== -1
                                    ? _c("span", [_vm._v("周二")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(3) !== -1
                                    ? _c("span", [_vm._v("周三")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(4) !== -1
                                    ? _c("span", [_vm._v("周四")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(5) !== -1
                                    ? _c("span", [_vm._v("周五")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(6) !== -1
                                    ? _c("span", [_vm._v("周六")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.checkedWeekdays &&
                                  row.checkedWeekdays.indexOf(7) !== -1
                                    ? _c("span", [_vm._v("周日")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "生效时间",
                          prop: "name",
                          align: "center",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n             " +
                                      _vm._s(row.beginTimeStr) +
                                      "-" +
                                      _vm._s(row.endTimeStr) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("tableFrom.Operation"),
                          align: "center",
                          width: "250",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleGroupItemEdit(
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                   编辑\n                 "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                            icon: "el-icon-delete",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleGroupItemDelete(
                                                row.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                   删除\n                 "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加分组",
            visible: _vm.groupAddVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.groupAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "分组名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleGroupAddFilter($event)
                  },
                },
                model: {
                  value: _vm.groupAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.groupAddQuery, "keywords", $$v)
                  },
                  expression: "groupAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleGroupAddFilter },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleBatchAddGroup },
                },
                [_vm._v("批量添加")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: "222",
              ref: "groupAddTable",
              staticStyle: { width: "100%" },
              attrs: {
                "max-height": "400px",
                data: _vm.groupAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  selectable: function (row) {
                    return !row.checked
                  },
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  prop: "id",
                  align: "center",
                  width: "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "分组名称（中）",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "分组名称（英）",
                  prop: "nameEn",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "分组icon", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.iconUrl === null ||
                        row.iconUrl === "" ||
                        row.iconUrl === undefined
                          ? _c("span", [
                              _vm._v("\n            未上传图片\n          "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: row.iconUrl,
                                fit: "contain",
                                "preview-src-list": [row.iconUrl],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "生效星期",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(1) !== -1
                          ? _c("span", [_vm._v("周一")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(2) !== -1
                          ? _c("span", [_vm._v("周二")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(3) !== -1
                          ? _c("span", [_vm._v("周三")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(4) !== -1
                          ? _c("span", [_vm._v("周四")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(5) !== -1
                          ? _c("span", [_vm._v("周五")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(6) !== -1
                          ? _c("span", [_vm._v("周六")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(7) !== -1
                          ? _c("span", [_vm._v("周日")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "生效时间",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.beginTimeStr) +
                            "-" +
                            _vm._s(row.endTimeStr) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.checked,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-plus",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGroup(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              添加\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.itemAddVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itemAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "菜品id/名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleItemAddFilter($event)
                  },
                },
                model: {
                  value: _vm.itemAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemAddQuery, "keywords", $$v)
                  },
                  expression: "itemAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleItemAddFilter },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.handleAddAll },
                },
                [_vm._v("添加")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: "333",
              ref: "itemAddTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.itemAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
                "max-height": "400px",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  prop: "goodsCode",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属大类",
                  prop: "categoryFirstName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属小类",
                  prop: "categorySecondName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.goodsThumbnailUrl === null ||
                        row.goodsThumbnailUrl === "" ||
                        row.goodsThumbnailUrl === undefined
                          ? _c("span", [
                              _vm._v("\n            未上传图片\n          "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: row.goodsThumbnailUrl,
                                fit: "contain",
                                "preview-src-list": [row.goodsThumbnailUrl],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.checked,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-plus",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGoods(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              添加\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemAddTotal > 0
            ? _c("sw-page", {
                key: "4",
                staticStyle: { display: "block", float: "none" },
                attrs: {
                  listQuery: _vm.itemAddQuery,
                  total: _vm.itemAddTotal,
                  pos: "btmRight",
                },
                on: { retPage: _vm.retPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            title: "同步菜单",
            visible: _vm.syncMenuVisible,
            size: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.syncMenuVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "syncMenuRef",
              staticClass: "dialog-form",
              attrs: { model: _vm.syncMenuForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "来源", prop: "source" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { max: 1 },
                      model: {
                        value: _vm.syncMenuForm.source,
                        callback: function ($$v) {
                          _vm.$set(_vm.syncMenuForm, "source", $$v)
                        },
                        expression: "syncMenuForm.source",
                      },
                    },
                    _vm._l(_vm.selectedScenes, function (scene) {
                      return _c(
                        "el-checkbox",
                        { key: scene, attrs: { label: scene } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getSceneLabel(scene)) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "同步至", prop: "to" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.syncMenuForm.to,
                        callback: function ($$v) {
                          _vm.$set(_vm.syncMenuForm, "to", $$v)
                        },
                        expression: "syncMenuForm.to",
                      },
                    },
                    _vm._l(
                      _vm.selectedScenes.filter(function (s) {
                        return s !== _vm.syncMenuForm.source[0]
                      }),
                      function (scene) {
                        return _c(
                          "el-checkbox",
                          {
                            key: scene,
                            attrs: {
                              label: scene,
                              disabled: !_vm.syncMenuForm.source.length,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getSceneLabel(scene)) +
                                "\n          "
                            ),
                          ]
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.syncMenuVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.syncMenu } },
                [_vm._v("同步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("storeMenuDialog", {
        attrs: {
          visible: _vm.storeMenuVisible,
          "selected-store-ids": _vm.storeMenuForm.relatedStoreIdList,
          "region-store-list": _vm.regionStoreList,
          loading: _vm.listLoading,
          "validate-func": _vm.validateStoreMenu,
        },
        on: {
          "update:visible": function ($event) {
            _vm.storeMenuVisible = $event
          },
          submit: _vm.handleSaveStoreMenu,
          close: _vm.handleStoreMenuClose,
        },
      }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "编辑明细",
            visible: _vm.editGroupItemVisible,
            size: "700px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editGroupItemVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.editGroupItemForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "time" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "起始时间",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:00",
                      },
                    },
                    on: { change: _vm.handleBeginTimeChange },
                    model: {
                      value: _vm.editGroupItemForm.beginTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editGroupItemForm, "beginTimeStr", $$v)
                      },
                      expression: "editGroupItemForm.beginTimeStr",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "结束时间",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": _vm.editGroupItemEndTimeOptions,
                    },
                    model: {
                      value: _vm.editGroupItemForm.endTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editGroupItemForm, "endTimeStr", $$v)
                      },
                      expression: "editGroupItemForm.endTimeStr",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效星期", prop: "weekdays" } },
                [
                  _c(
                    "el-checkbox",
                    { on: { change: _vm.handleCheckAllChange } },
                    [_vm._v("全选")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { margin: "15px 0" } }),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.editGroupItemForm.checkedWeekdays,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.editGroupItemForm,
                            "checkedWeekdays",
                            $$v
                          )
                        },
                        expression: "editGroupItemForm.checkedWeekdays",
                      },
                    },
                    _vm._l(_vm.weekdays, function (day) {
                      return _c(
                        "el-checkbox",
                        { key: day.value, attrs: { label: day.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(day.label) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editGroupItemVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleUpdateGroupItem },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "编辑模板",
            visible: _vm.editTemplateVisible,
            size: "500px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editTemplateVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editTemplateFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: {
                model: _vm.editTemplateForm,
                "label-width": "120px",
                rules: _vm.editTemplateRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editTemplateForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editTemplateForm, "name", $$v)
                      },
                      expression: "editTemplateForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        disabled: "",
                        placeholder: "模板类型",
                        clearable: "",
                      },
                      model: {
                        value: _vm.editTemplateForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.editTemplateForm, "type", $$v)
                        },
                        expression: "editTemplateForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        key: "普通模板",
                        attrs: { label: "普通模板", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "分时模板",
                        attrs: { label: "分时模板", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.editTemplateForm.type == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "生效时间", prop: "time" } },
                    [
                      _c("el-time-picker", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          placeholder: "起始时间",
                          "value-format": "HH:mm",
                          format: "HH:mm",
                          "picker-options": {
                            selectableRange: "00:00:00 - 23:59:00",
                          },
                        },
                        on: { change: _vm.handleTemplateBeginTimeChange },
                        model: {
                          value: _vm.editTemplateForm.beginTimeStr,
                          callback: function ($$v) {
                            _vm.$set(_vm.editTemplateForm, "beginTimeStr", $$v)
                          },
                          expression: "editTemplateForm.beginTimeStr",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-time-picker", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          placeholder: "结束时间",
                          "value-format": "HH:mm",
                          format: "HH:mm",
                          "picker-options": _vm.editTemplateEndTimeOptions,
                        },
                        model: {
                          value: _vm.editTemplateForm.endTimeStr,
                          callback: function ($$v) {
                            _vm.$set(_vm.editTemplateForm, "endTimeStr", $$v)
                          },
                          expression: "editTemplateForm.endTimeStr",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editTemplateForm.type == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "生效星期", prop: "weekdays" } },
                    [
                      _c(
                        "el-checkbox",
                        { on: { change: _vm.handleCheckAllChange } },
                        [_vm._v("全选")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { margin: "15px 0" } }),
                      _vm._v(" "),
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.editTemplateForm.checkedWeekdays,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.editTemplateForm,
                                "checkedWeekdays",
                                $$v
                              )
                            },
                            expression: "editTemplateForm.checkedWeekdays",
                          },
                        },
                        _vm._l(_vm.weekdays, function (day) {
                          return _c(
                            "el-checkbox",
                            { key: day.value, attrs: { label: day.value } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(day.label) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editTemplateVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSaveTemplate },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "预览模板",
            visible: _vm.previewDialogVisible,
            width: "500px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.previewLoading,
                  expression: "previewLoading",
                },
              ],
              staticClass: "preview-qrcode-container",
            },
            [
              _c("div", { staticClass: "preview-info" }, [
                _c("p", [
                  _c("strong", [_vm._v("模板名称：")]),
                  _vm._v(_vm._s(_vm.baseInfo.name)),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("当前场景：")]),
                  _vm._v(_vm._s(_vm.getSceneLabel(_vm.selectScene))),
                ]),
              ]),
              _vm._v(" "),
              _vm.previewQrCode
                ? _c(
                    "div",
                    { staticClass: "qrcode-wrapper" },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "280px", height: "280px" },
                          attrs: { src: _vm.previewQrCode, fit: "contain" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "placeholder" },
                              slot: "placeholder",
                            },
                            [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("加载中...")]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "preview-tip" }, [
                _c("p", [_vm._v("使用微信扫描二维码，在小程序中预览模板效果")]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "dialog-footer-row" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.previewDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-download" },
                      on: { click: _vm.downloadQrCode },
                    },
                    [_vm._v("下载模板二维码")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-footer-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-download",
                        loading: _vm.downloadAllLoading,
                      },
                      on: { click: _vm.downloadAllStoreQrCodes },
                    },
                    [_vm._v("全门店预览码")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "warning",
                        icon: "el-icon-download",
                        loading: _vm.totalQrCodeLoading,
                      },
                      on: { click: _vm.handleGenerateTotalQrCode },
                    },
                    [_vm._v("总预览码")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }